<template>
  <Newsletter
    :headline="headline"
    :placeholder="placeholder"
    :buttonText="buttonText"
    :description="description"
    :buttonColorVariant="buttonColorVariant"
    :image="newImage"
  />
</template>

<script>
  import Newsletter from 'building-blocks/components/Newsletter.vue';

  export default {
    components: { Newsletter },
    props: {
      variant: {
        type: String,
        default: ''
      },
      headline: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      buttonText: {
        type: String,
        default: ''
      },
      description: {
        type: String,
        default: ''
      },
      fontColor: {
        type: String,
        default: ''
      },
      buttonColorVariant: {
        type: String,
        default: ''
      },
      image: {
        type: Object,
        default: {}
      },
    },
    data() {
      return {
        newImage: {}
      };
    },
    mounted() {
      if(typeof this.image == 'object' && Object.keys(this.image).length > 0) {
        this.newImage = {
          link: this.image['@path'] ?  process.env.VUE_APP_MGNL_HOST + '/dam' + this.image['@path'] : null,
          alt: this.image.metadata?.title ? this.image.metadata.title : this.image['@name']
        };
      }
    }
  };
</script>
